<svelte:options
  customElement={{
    tag: "fixed-banner",
    shadow: "none"
  }}
/>
<script>
  import{fly} from "svelte/transition"
  import {breakPoint} from "@util/constant"
  let {
    url = "https://minna-no-ginko.go.link/bwUec",
    text = "アプリをダウンロード",
    sendID = "common-follow-app"
  } = $props();

  let width =  $state(0)
  let scroll = $state(0)
  let deviceHeight = $state(0)

  let lastScrollY = 0; // Previous scroll position
  let isScrollingUp = $state(false); // Scroll direction state

  $effect(() => {
    // Determine scroll direction based on the change in `scroll`
    isScrollingUp = scroll > lastScrollY;
    lastScrollY = scroll <= 0 ? 0 : scroll; // Update last scroll position
  });
</script>

<svelte:window bind:innerWidth={width} bind:scrollY={scroll} bind:innerHeight={deviceHeight} />

{#if isScrollingUp && breakPoint > width && deviceHeight < scroll}


  <div class="fixed-banner" transition:fly={{y:-10,duration:400}}>
    <div class="fixed-banner-left">
      <img src="/assets_default/icons/app_icon.svg" alt="Minna no Ginko">
      <div class="fixed-banner-textarea">
        <p class="owd-text:02 text-color:white spacing:bottom:4"><strong>みんなの銀行</strong></p>
        <span class="owd-caption text-color:white">スマホで完結</span>
      </div>
    </div>
    <div class="fixed-banner-right">
      <a href={url} id={sendID} class="owd-button owd-button:small owd-button:primary:white" style="word-break: keep-all;">{text}</a>
    </div>
  </div>
{/if}

<style lang="scss">
  .fixed-banner {
    padding: 12px 16px;
    display: grid;
    grid-template-columns: 1fr 177px;
    gap: 8px;
    align-items: center;
    position: fixed;
    top: 0;
    background: #000;
    z-index: 9;
    left: 0;
    width: 100%;
  }
  .fixed-banner-left {
    display: grid;
    grid-template-columns: 48px 1fr;
    gap: 8px;
    align-items: center;
  }

  .fixed-banner-textarea {
    .owd-caption{
      // letter-spacing: .06px;
      @include g.owd-typography($fz: 'caption', $line-height-px: 16, $letter-spacing-tracking: 50, $font-weight: var(--base-normal-weight));
    }
  }
</style>
